<template>
  <div />
</template>

<script>
export default {
  props: {
    fbPixel: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.checkIfFbqLoaded()
  },
  methods: {
    checkIfFbqLoaded() {
      if (window.ga) {
        if (typeof window.fbq !== 'undefined' && this.fbPixel !== '') {
          if (this.$store.state.pixels.fbPixels.indexOf(this.fbPixel) === -1) {
            eval(this.fbPixel)
            this.$store.dispatch('pixels/setFbPixel', this.fbPixel)
            window.fbq('track', 'PageView')
          }
        }
      } else {
        setTimeout(this.checkIfFbqLoaded, 200)
      }
    }
  }
}
</script>
